import React from 'react';
import { useDispatch } from 'react-redux';

// components
import Time from './time/Time';
import TicketDetails from './activeTicket/TicketDetails';
import CustomerDetails from './activeTicket/CustomerDetails';

import { modalUpdate } from "../../../store/actions/settingsActions";
import { updateActiveManagementTicketId } from "../../../store/actions/ticketsActions";

function ActiveTicket({ ticket, customer }) {
    const dispatch = useDispatch();
    const breachColor = '#F87171';
    const isBreached = (
        ticket
        && ticket.slaBreached
        && ticket.slaBreach
        && ticket.slaBreach.breachType === 'active-service-time'
        && Number(ticket.status) === 1
    );
    const ticketBorder = isBreached
        ? `4px solid ${breachColor}`
        : Number(ticket?.status)
            ? "6px solid #ffe163"
            : "";
    const handleModalClick = (id = null) => {
        id = id != null ? id : ticket.id;
        dispatch(updateActiveManagementTicketId(id));
        dispatch(modalUpdate({ visible: 1, content: "TicketManagement", modalType: 1 }));
    };

    return (
        <div className="home-time-supportDesk-top-wraper" style={{ border: ticketBorder }}>
            {
                (Number(ticket?.status) || isBreached)
                ? (
                    <>
                        <div className="ticketCutout" style={{background: isBreached ? breachColor : "#ffe163"}}></div>
                        <div className="ticketCutout" style={{background: isBreached ? breachColor : "#ffe163"}}></div>
                        <div className="ticketDash"></div>
                    </>
                )
                : null
            }
            {
                ticket != null 
                ? (
                    <>
                        <div className="home-time-supportDesk-top">
                            <div className="titleBlock">
                                <h4>{ticket.status === 1 ? 'Current Ticket' : 'Next Ticket'}</h4>
                                <div className="home-time-supportDesk-with-btn">
                                    <h3>{ticket.status ? <Time created={ticket.sessionStart} /> : null}</h3>
                                <div className="manageBtn" onClick={() => handleModalClick(ticket.id)}>Manage</div>
                            </div>
                        </div>
                    </div>
                    <div className="home-time-supportDesk-main">
                        <>
                            <TicketDetails ticket={ticket} isActive={Number(ticket.status)} />
                            <CustomerDetails ticket={ticket} customer={customer} />
                        </>
                    </div>
                    {/* <AudioRecording /> */}
                    </>
                )
                : (
                    <div className="emptyQueue">
                        <div>Queue is empty</div>
                        <div>There are currently no customers in your queue</div>
                        <svg width="30" height="20" viewBox="0 0 30 20" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M28 2L14.067 17.938L8.3445 12.2326M7.78469 18L2 12.2326M21.6555 2L13.756 11.0543" stroke="white" strokeWidth="2" strokeMiterlimit="10" strokeLinecap="square"/>
                    </svg>
                </div>
                )
            }
        </div>
    );
}

export default ActiveTicket;
